import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector, reset } from "redux-form";
import { renderInput, renderTextArea, renderDatePicker, renderDropdown, renderCheckbox } from "../../common/renderinput";
import { FormGroup } from 'reactstrap';
import classnames from 'classnames';
import { connect } from "react-redux";


var userTypes = [
    {textField : 'Client', valueField:'Client'},
    {textField : 'Admin', valueField:'Admin'}
];
const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
  'Invalid email address' : undefined

const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? 'Invalid phone number, must be 10 digits'
    : undefined

class UserForm extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
             activeTab: '1'
        };
    }

    render() {

        return (

                <FormGroup>
                    <Field name="Username" component={renderInput}   validate={email}  isLabel={true} label="Email" />
                    <Field name="Name" component={renderInput}   isLabel={true}   label="Name" />
                    <Field name="Phone" component={renderInput} validate={phoneNumber} isLabel={true}   label="Phone" />
                    <Field name="CompanyId" component={renderDropdown}      
                            data={this.props.companylist} valueField={'valuefield'} textField={'textfield'}
                        isLabel={true}   label="Company" />
                    <Field name="UserType" component={renderDropdown}      
                            data={userTypes} valueField={'valueField'} textField={'textField'}
                        isLabel={true}   label="User Type" />
                </FormGroup>
        )


    }
}
var s = connect(state => ({
    companylist: state.User.company,
}))(UserForm);
export default s;